module.exports = __webpack_public_path__ + "static/media/School_building.1b4c662d.svg";